import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  completedOrder: null,
};

const orderSlice = createSlice({
  name: "order",

  initialState,

  reducers: {
    setCompletedOrder(state, action) {
      state.completedOrder = action.payload;
    },

    clearCompletedOrder(state) {
      state.completedOrder = null;
    },
  },
});

export const { setCompletedOrder, clearCompletedOrder } = orderSlice.actions;

export default orderSlice.reducer;
